import { exists } from '@/api'

export interface DeleteReserveRequestReserve {
  id: number
  revision: number
  _reserveAssign?: boolean
}

export function DeleteReserveRequestReserveFromJSON(
  json: any
): DeleteReserveRequestReserve {
  return DeleteReserveRequestReserveFromJSONTyped(json)
}

export function DeleteReserveRequestReserveFromJSONTyped(
  json: any
): DeleteReserveRequestReserve {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: exists(json, 'id') ? json.id : 0,
    revision: exists(json, 'revision') ? json.revision : 0,
    _reserveAssign: undefined
  }
}

export function DeleteReserveRequestReserveToJSON(
  value: DeleteReserveRequestReserve
): any {
  return {
    id: value.id,
    revision: value.revision,
    _reserve_assign: value._reserveAssign ?? undefined
  }
}
